/* eslint-disable no-unused-vars */
import {
  Box, Theme, Typography, useTheme
} from '@mui/material';
import React from 'react';
import CommonButtonProps from './ETOButtonCommonProps';
import commonButtonStyles from './ETOButtonCommonStyles';

const countSx = (theme: Theme) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0.5),
  borderRadius: theme.spacing(0.5),
  marginLeft: theme.spacing(1),
});

// eslint-disable-next-line no-shadow
enum Styles {
  primary = 'primaryCount',
  secondary = 'secondaryCount',
  error = 'errorCount',
  success = 'successCount',
  warning = 'warningCount',
  grey = 'greyCount',
}

interface CountProps extends Pick<CommonButtonProps, 'color'> {
  count: number;
}

const Count: React.FC<React.PropsWithChildren<CountProps>> = (props: CountProps) => {
  const { count, color } = props;
  const theme = useTheme();
  const commonStyles = commonButtonStyles(theme);

  return (
    <Box
      sx={[
        countSx,
        commonStyles[Styles[color]],
      ]}
      data-testid="count"
    >
      <Typography
        data-testid="text"
        variant="caption"
        sx={{
          lineHeight: 1,
          fontWeight: 'bold',
        }}
      >
        {count}
      </Typography>
    </Box>
  );
};

export default Count;
